import fetchClient from './index';
import {BASE_URL, endPoints} from './urls';

export const dailyReminder = async () => {
  try {
    const response = await fetchClient().get(`${BASE_URL}${endPoints.DAILY_REMINDER}`);
    return response;
  } catch (e) {
    console.log('errorrr', e);
    return e;
  }
};

export const addBookMarkDailyReminder = async (payload: any) => {
  try {
    const response = await fetchClient().post(
      `${BASE_URL}${endPoints.ADD_DAILY_REMINDER_BOOKMARK}`,
      payload
    );
    return response;
  } catch (e) {
    console.log('errorrr', e);
    return e;
  }
};

export const deleteBookMarkDailyReminder = async (id: any) => {
  try {
    const response = await fetchClient().delete(
      `${BASE_URL}${endPoints.DELETE_DAILY_REMINDER_BOOKMARK(id)}`
    );
    return response;
  } catch (e) {
    console.log('errorrr', e);
    return e;
  }
};
